export class RecuperarSenhaModel {
    email: String
}